import { gql, useQuery } from "@apollo/client";
import { Franchisee } from "../gql/graphql.ts";

export const GetFranchiseeByIdQuery = gql`
  query getFranchiseeById($id: String!) {
    getFranchiseeById(id: $id) {
      id
      email
      familyName
      givenName
      phoneNumber {
        countryCode
        number
      }
      userGroupIds
      authId
      lesson1on1
      internalTeacher
    }
  }
`;

export type FranchiseeWithInternalTeacher = Franchisee & {
  internalTeacher?: boolean | null;
};

export function useFranchiseeById(franchiseeId: string) {
  const { data, loading } = useQuery(GetFranchiseeByIdQuery, {
    variables: {
      id: franchiseeId as string,
    },
  });
  return {
    franchisee: (data?.getFranchiseeById ?? undefined) as
      | FranchiseeWithInternalTeacher
      | undefined,
    loading,
  };
}
